import { render, staticRenderFns } from "./reply-new-sme-refer.vue?vue&type=template&id=228c2f57&scoped=true&"
import script from "./reply-new-sme-refer.vue?vue&type=script&lang=js&"
export * from "./reply-new-sme-refer.vue?vue&type=script&lang=js&"
import style0 from "./reply-new-sme-refer.vue?vue&type=style&index=0&id=228c2f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c2f57",
  null
  
)

export default component.exports